import { Component, Inject, Injector, Input, Optional, TemplateRef, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import {
    ExperienceLevelType,
    IAccessTable,
    IAppSettingsWrap,
    IAppStatic,
    ICredentialsDataWrap,
    ICredentialsWrap,
    ICRUDCommand,
    Id,
    IPlayerProps,
    IStation,
    IStationData,
    IUser,
} from "../../../interfaces";
import { ToastrService } from "ngx-toastr";
import { SelectionModel } from "@angular/cdk/collections";
import { LazyImage } from "../../../components/lazy-image/lazy-image";
import { EnterpriseService } from "../../enterprise/services/enterprise-service";
import { StationSnapshotComponent } from "../station-snapshot/station-snapshot.component";
import { combineLatest, from, Observable, of, pairwise } from "rxjs";
import {
    compareIds,
    isHostDevOrLocal,
    isNullOrUndefOrEmpty,
    timeFormatToSeconds,
    timeSecondsToFormat,
} from "../../../common";
import { TranslocoService } from "@ngneat/transloco";
import { ActivatedRoute, Router } from "@angular/router";
import { SceneMimeTypes } from "../../editor/scene-blocks/mime-constants";
import {
    DialogGetAssetComponent,
    IDialogGetAsset,
} from "../../../components/dialog-get-asset/dialog-get-asset.component";
import { delay, filter, map, mergeMap, startWith, switchMap, take } from "rxjs/operators";
import { FormBuilder, FormGroup } from "@angular/forms";
import {
    AccessService,
    ContainerService,
    LocalStoreService,
    StoreSelectorsService,
    UserService,
} from "../../../services";
import {
    actionCRUDRecord,
    actionLoadStationRemove,
    actionLoadStationUpdate,
    actionStationV1V2Update,
} from "../../../store/actions/user.actions";
import { IGroupCollection } from "../../../interfaces/enterprise-interface";
import { Compbaser } from "../../../components/compbaser";
import { actionEnterpriseSendAllCommand, actionEnterpriseStationSave } from "app/store/actions/enterprise.actions";
import { HttpClient } from "@angular/common/http";
import { retryWithBackoff } from "../../../../libs/rxjs/retryWithBackoff";
import { Lib } from "../../../../libs/Lib";
import { StationLiveComponent } from "../station-live/station-live.component";
import { DialogCategoryTreeComponent } from "../../../components/dialog-category-tree/dialog-category-tree.component";
import { IPlayerService } from "@signage/lib";
import * as _ from "lodash";
import { ActionsSubject } from "@ngrx/store";
import { ofType } from "@ngrx/effects";

@Component({
    selector: "app-station-props",
    templateUrl: "./station-props.component.html",
    styleUrls: ["./station-props.component.scss"],
})
export class StationPropsComponent extends Compbaser {
    commandSending = false;
    scenesSimple: { name, sceneId }  [];
    scenes: IPlayerProps[] = [];
    priorityLevels = [
        { level: "0", name: "error" },
        { level: "1", name: "warning" },
        { level: "2", name: "info" },
        { level: "3", name: "debug" },
    ];
    multipleCommands = ["start", "stop", "syncAndStart", "pushNewContent"];
    coreAppData: IAppSettingsWrap;
    selectionModel: SelectionModel<number>;
    selectedStation: IStationData;
    selectedStationSource;
    formGroup: FormGroup;
    dashboard = false;
    debugMode = false;
    logTagsDB = [];
    assignedScene;
    once = false;
    captureEnabled = false;
    modeBiosEnabled;
    modeRebootExceedMemEnabled;
    modeRebootTimeEnabled;
    modeRebootErrorEnabled;
    lanServerEnabled;
    accessConfig: IAccessTable;
    groupCollection: IGroupCollection;
    categories = [];
    stringJSPipeArgs = { split: [".", "0"] };
    pushNewContentColor = false;
    restartPlayerOnSceneAssignment;
    inFocusName = null;
    user: IUser;
    m_businessId = "";
    waitingSnap = false;
    isFullFeatures: boolean;
    rebootDiag;
    rebootModal = "1";
    appStatic: IAppStatic;

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    @ViewChild(LazyImage) lazyImage: LazyImage;
    @ViewChild(StationSnapshotComponent) stationSnapshotComponent: StationSnapshotComponent;
    @ViewChild("rebootDialog", { read: TemplateRef }) rebootDialog: TemplateRef<any>;

    // @ViewChild("stationDetails", {read: TemplateRef}) stationDetails: TemplateRef<any>;

    @Input()
    set setSelectionModel(i_selectionModel) {
        this.selectionModel = i_selectionModel;
        this.inPanelMode();
        this.once = true;
    }

    constructor(@Optional() @Inject(MAT_DIALOG_DATA) data, public override dialog: MatDialog,
                private injector: Injector,
                private accessService: AccessService,
                private _http: HttpClient,
                private actionsSubj: ActionsSubject,
                private userService: UserService,
                private storeSelector: StoreSelectorsService,
                private toastr: ToastrService,
                private containerService: ContainerService,
                private enterpriseService: EnterpriseService,
                private translocoService: TranslocoService,
                private route: ActivatedRoute,
                public router: Router,
                private localStoreService: LocalStoreService,
                private formBuilder: FormBuilder) {
        super();
        this.debugMode = isHostDevOrLocal();
        this.restartPlayerOnSceneAssignment = this.localStoreService.getStorageValConfig("restartPlayerOnSceneAssignment");
        this.formGroup = this.formBuilder.group({
            station_id: [],
            station_name: [],
            reboot_exceed_mem_enabled: [],
            reboot_exceed_mem_value: [],
            reboot_time_enabled: [],
            reboot_time_value: [],
            reboot_error_enabled: [],
            monitor_standby_enabled: [],
            monitor_standby_from: [],
            monitor_standby_to: [],
            location_address: [],
            location_long: [],
            location_lat: [],
            map_type: [],
            map_zoom: [],
            station_selected: [],
            advertising_description: [],
            advertising_keys: [],
            reboot_exceed_mem_action: [],
            reboot_time_action: [],
            reboot_error_action: [],
            station_mode: [],
            power_mode: [],
            power_on_day1: [],
            power_off_day1: [],
            power_on_day2: [],
            power_off_day2: [],
            power_on_day3: [],
            power_off_day3: [],
            power_on_day4: [],
            power_off_day4: [],
            power_on_day5: [],
            power_off_day5: [],
            power_on_day6: [],
            power_off_day6: [],
            power_on_day7: [],
            power_off_day7: [],
            send_notification: [],
            tracking: [],
            frame_rate: [],
            quality: [],
            transition_enabled: [],
            lan_server_enabled: [],
            lan_server_ip: [],
            lan_server_port: [],
            camera_enabled: [],
            camera_preset_url: [],
            camera_snapshot_url: [],
            camera_test_on_update: [],
            camera_schedule_enabled: [],
            camera_schedule_time: [],
            adnet_target_id: [],
            player_data_id: [],
            assigned_to: [],
            tree_path: [],
            log_enabled: [],
            log_tags: [],
            log_priority: [],
        });
        // this.cod(
        //     this.actionsSubj.pipe(ofType(actionLoadStationV2LogReply))
        //         .subscribe((reply: any) => {
        //             if (reply.logs.length === 0) return;
        //             const playerService: IPlayerService = this.injector.get('playerService');
        //         })
        // );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                }),
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            }),
        );
        this.cod(
            this.accessService.getGroupsTable("SignStudio Players", "players")
                .subscribe((v) => {
                    this.accessConfig = v;
                }),
        );
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                this.user = user;
                this.m_businessId = user.businessId;
                // if (this.isFullFeatures) {
                //     this.loadStationLog();
                // }
            }),
        );
        this.cod(
            this.accessService.getGroupsCollection("SignStudio Players")
                .pipe(
                    map((value) => value),
                ).subscribe((v) => {
                this.groupCollection = v;
            }),
        );
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => {
                    this.coreAppData = i_coreData;
                    this.dashboard = i_coreData[0].dashboard;
                }),
        );
        this.cod(
            this.formGroup.valueChanges.pipe(startWith(null), pairwise())
                .subscribe(([prev, curr]) => {
                    if (this.selectionModel.selected.length == 1) {
                        this.updateSingle(curr);
                    } else if (this.selectionModel.selected.length > 1) {
                        // this.updateMultiple();
                        return;
                    }
                    this.waitingSnap = false;
                }),
        );
        this.cod(
            this.storeSelector.getScenes(true)
                .subscribe((i_scenes: IPlayerProps[]) => {
                    this.scenes = _.orderBy(i_scenes, (v: IPlayerProps) => {
                        return v.Player.$.label.toLocaleLowerCase();
                    }, ["asc"]);
                    this.scenesSimple = [];
                    this.scenes.forEach((scene) => {
                        if (this.storeSelector.isMainScenePlayerOnly(scene.Player.$.mimeType) || scene.Player.$.mimeType.length === 0) {
                            this.scenesSimple.push({ name: scene.Player.$.label, sceneId: scene.Player.$.id });
                        }
                    });
                }),
        );
        this.cod(
            this.containerService.getCategories().subscribe(i_categories => {
                this.categories = i_categories ? i_categories : [];
            }),
        );
        this.cod(
            actionsSubj.pipe(ofType(actionEnterpriseSendAllCommand))
                .subscribe((action) => {
                    this.sendCommand(action.command);
                }),
        );
        if (data) {
            this.selectionModel = data.selectionModel;
            this.inDialogMode();
        }

        this.experienceLevel = this.localStoreService.getStorageValConfig("experienceLevel"); // Alon
        this.cod(
            this.storeSelector.getLocalStoreUpdates("ILocalStorageConfig").subscribe((e) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig("experienceLevel"); // Alon
            }),
        );
    }

    inPanelMode() {
        if (this.once) return;
        // const stationTracking$ = this.storeSelector.getStationTracking();
        const userStations$ = this.storeSelector.getStationsComplete();
        const changed$ = this.selectionModel.changed;
        this.cod(
            changed$.subscribe((v) => {
                this.waitingSnap = false;
                this.resetProperties();
            }),
        );
        this.cod(
            changed$.subscribe((v) => {
                if (this.selectionModel.selected.length === 1 && this.stationSnapshotComponent) {
                    this.stationSnapshotComponent.resetSnapshotSelection();
                }
            }),
        );
        // combineLatest([changed$, userStations$, stationTracking$]).pipe(map(([a, stationsData, stationTracking]) => {
        this.cod(
            combineLatest([changed$, userStations$]).pipe(map(([a, stationsData]) => {
                this.captureEnabled = this.selectionModel.selected.length === 1;
                if (this.selectionModel.selected.length === 0) return null;
                return this.selectionModel.selected.map((stationBusinessId) => {
                    return stationsData.find((s) => s.props.station_business_id === String(stationBusinessId));
                });
            })).subscribe((value) => {
                if (this.selectionModel.selected.length > 1) {
                    // this.resetProperties();
                } else {
                    this.loadProperties(value);
                }
            }),
        );
    }

    inDialogMode() {
        this.cod(
            this.storeSelector.getStationsComplete().pipe(
                map((b) => {
                    return this.selectionModel.selected.map((stationBusinessId) => {
                        return b.find((s) => s.props.station_business_id === String(stationBusinessId));
                    });
                }))
                .subscribe((value) => {
                    this.loadProperties(value);
                }),
        );
    }

    onSnapCompleted(event) {
        if (event.status === "error" || event.status === "completed") {
            this.waitingSnap = false;
        }
    }

    onFocusChanged(e) {
        this.inFocusName = e;
    }

    resetProperties() {
        this.selectedStation = null;
        this.modeBiosEnabled = null;
        this.modeRebootExceedMemEnabled = null;
        this.modeRebootTimeEnabled = null;
        this.modeRebootErrorEnabled = null;
        this.lanServerEnabled = null;
        this.captureEnabled = false;
        Object.keys(this.formGroup.controls).forEach((key, index) => {
            this.formGroup.controls[key].patchValue("", { emitEvent: false, onlySelf: true });
        });
        // set default station name
        // this.formGroup.controls['station_name'].patchValue('Stations', {emitEvent: false, onlySelf: true});
    }

    // @debouncer(100)
    loadProperties(stations: IStationData[]) {
        if (stations?.length > 1) return;
        if (!stations) {
            this.selectedStation = null;
            this.captureEnabled = false;
            this.modeBiosEnabled = null;
            this.modeRebootExceedMemEnabled = null;
            this.modeRebootTimeEnabled = null;
            this.modeRebootErrorEnabled = null;
            this.lanServerEnabled = null;
            return;
        }

        if (stations.length === 1 && stations[0]?.stat) {
            this.selectedStation = stations[0];
            this.selectedStationSource = this.selectedStation.stat.$.source || this.coreAppData[0].businessDomain;
            this.captureEnabled = true;
            this.modeBiosEnabled = this.selectedStation.props.power_mode;
            this.modeRebootExceedMemEnabled = this.selectedStation.props.reboot_exceed_mem_enabled;
            this.modeRebootTimeEnabled = this.selectedStation.props.reboot_time_enabled;
            this.modeRebootErrorEnabled = this.selectedStation.props.reboot_error_enabled;
            this.lanServerEnabled = this.selectedStation.props.lan_server_enabled;

            Object.keys(this.formGroup.controls).forEach((key, index) => {
                if (key === "reboot_time_value") {
                    const tt = timeSecondsToFormat(String((this.selectedStation.props.reboot_time_value)));
                    this.formGroup.controls["reboot_time_value"].patchValue(`${tt.split(":")[1]}:${tt.split(":")[2]}:00`, {
                        emitEvent: false,
                        onlySelf: true,
                    });

                } else if (key.match("power_on_day") || key.match("power_off_day")) {
                    const tt = timeSecondsToFormat(String(this.selectedStation.props[key]));
                    this.formGroup.controls[key].patchValue(tt, { emitEvent: false, onlySelf: true });

                } else if (key.match("log_priority")) {
                    const idx = this.priorityLevels.findIndex((i) => {
                        return compareIds(i.level, this.selectedStation.props?.log_priority);
                    });
                    this.formGroup.controls[key].patchValue(this.priorityLevels[idx], {
                        emitEvent: false,
                        onlySelf: true,
                    });
                    if (this.isFullFeatures) {
                        const playerService: IPlayerService = this.injector.get("playerService");
                        const tags = playerService.getLogTags();
                        this.logTagsDB = [];
                        tags.forEach((tagName) => {
                            if (this.selectedStation?.props?.log_tags?.match(tagName)) {
                                this.logTagsDB.push({ name: tagName, value: true });
                            } else {
                                this.logTagsDB.push({ name: tagName, value: false });
                            }
                        });
                    }
                } else {
                    /** don't update a control that is currently in focus **/
                    if (key === this.inFocusName) return;
                    this.formGroup.controls[key].patchValue(this.selectedStation["props"][key], {
                        emitEvent: false,
                        onlySelf: true,
                    });
                }
            });
            // this.updateTracking();
            return;
        }
    }

    openSceneAssignmentDialog() {
        if (this.accessConfig?.upd === false) return this.accessService.showNoAccess();
        const data: IDialogGetAsset = { mode: "SCENE:PLAYER_ASSIGNABLE", mimeType: SceneMimeTypes.Player };
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: "70%",
            panelClass: "custom-dlg-container",
            data,
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((result: IDialogGetAsset) => {
                    if (!result) return;
                    // this.assignSceneName();
                    this.onSceneChange({ value: result.selected });
                }),
        );
    }

    stopEnter(e): boolean {
        e.stopImmediatePropagation();
        e.preventDefault();
        return false;
    }

    private fixPowerTime(station) {
        for (let i = 1; i < 8; i++) {
            const keyOn = "power_on_day" + i;
            const keyOff = "power_off_day" + i;
            station[keyOn] = timeFormatToSeconds(this.formGroup.controls[keyOn].value);
            station[keyOff] = timeFormatToSeconds(this.formGroup.controls[keyOff].value);
        }
    }

    private fixPriority(station) {
        // only for v2 stations
        if (this.formGroup.controls?.log_priority?.value?.level) {
            station.log_priority = this.formGroup.controls.log_priority.value.level;
        }
    }

    private fixRebootTime(station) {
        const t1 = this.formGroup.controls["reboot_time_value"].value;
        const t2 = `00:${t1.split(":")[0]}:${t1.split(":")[1]}`;
        station.reboot_time_value = timeFormatToSeconds(t2);
    }

    updateSingle(station: IStation) {
        if (this.accessConfig?.upd === false) return this.accessService.showNoAccess();
        if (!this.selectedStation) return;

        const i_station = _.cloneDeep(station);

        this.fixRebootTime(i_station);
        this.fixPowerTime(i_station);
        this.fixPriority(i_station);
        i_station.station_business_id = String(this.selectionModel.selected[0]);

        if (!this.dashboard) {
            this.storeSelector.dispatch(actionLoadStationUpdate({ value: i_station }));
        } else {
            this.storeSelector.dispatch(actionEnterpriseStationSave({
                station_business_id: station.station_business_id,
                values: [
                    { key: "name", value: station.station_name },
                    { key: "tree_path", value: station.tree_path },
                ],
            }));
        }
        const uploadData = _.cloneDeep(i_station);
        delete uploadData["name"];
        delete uploadData["station_id"];
        delete uploadData["station_business_id"];
        this.crudStation("update", station.station_id, uploadData, this.selectedStation.props.version);
    }

    updateMultiple(key, value) {
        if (this.accessConfig?.upd === false) return this.accessService.showNoAccess();
        this.selectionModel.selected.forEach((stationBusinessId) => {
            const station: IStation = {
                station_business_id: String(stationBusinessId),
                station_id: String(stationBusinessId).split("_")[0],
            };
            station[key] = value;
            // Object.keys(this.formGroup.controls).forEach((key, index) => {
            //     if (key === 'station_id' || key === 'station_business_id') return;
            //     station[key] = this.formGroup.controls[key].value;
            // });
            // this.fixRebootTime(station);
            // this.fixPowerTime(station);

            if (!this.dashboard) {
                this.storeSelector.dispatch(actionLoadStationUpdate({ value: station }));
            }

            const uploadData = _.cloneDeep(station);
            delete uploadData["station_id"];
            delete uploadData["station_business_id"];
            this.crudStation("update", station.station_id, uploadData, "2");
            // this.crudStation('update', station.station_id, station, this.selectedStation.props.version);
        });
        // this.saveStationTracking();
        // this.selectionModel.clear();
    }

    onUpdateCategory(event: string) {
        if (this.selectionModel.selected.length > 1) {
            this.formGroup.controls["tree_path"].patchValue(event, { emitEvent: false, onlySelf: true });
        } else {
            this.formGroup.patchValue({ tree_path: event });
        }
    }

    onSceneChange(e) {
        if (this.selectionModel.selected.length > 1) {
            this.formGroup.controls["player_data_id"].patchValue(e.value, { emitEvent: false, onlySelf: true });
            this.updateMultiple("player_data_id", e.value);

        } else {
            this.formGroup.patchValue({ player_data_id: e.value });
        }
        if (this.restartPlayerOnSceneAssignment === "1") {
            setTimeout(() => {
                this.sendCommand("start");
            }, 300);
        } else {
            this.pushNewContentColor = true;
            setTimeout(() => {
                this.pushNewContentColor = false;
            }, 3000);
        }
    }

    onRebootHardOrSoft() {
        if (this.selectedStation.stat.$?.version !== "2") {
            /** legacy player **/
            if (this.rebootModal === "1") {
                this.onCommand("rebootPlayer");
            } else {
                this.onCommand("rebootStation");
            }
        } else {
            /** pwa player **/
            if (this.rebootModal === "1") {
                this.onCommand("start");
            } else {
                this.onCommand("rebootStation");
            }
        }
    }

    onCommand(i_command, eventName = "") {
        if (this.commandSending) return;
        this.commandSending = true;
        setTimeout(() => {
            this.commandSending = false;
        }, 2000);

        switch (i_command) {
            case "syncAndStart":
            case "start":
            case "stop":
            case "pushNewContent":
            case "clearCaching":
            case "checkUpdates":
            case "readLog":
            case "clearLog":
            case "rebootStation":
            case "rebootPlayer": {
                if (!this.multipleCommands.includes(i_command) && !this.isSingleStationAndConnected()) return;
                if (this.accessConfig?.upd === false) return this.accessService.showNoAccess();
                this.sendCommand(i_command);
                break;
            }
            case "remove": {
                if (this.accessConfig?.upd === false) return this.accessService.showNoAccess();
                return this.openDialog(this.translocoService.translate("toast.sureWantDelPlayer", {}, this.translocoService.getActiveLang()), { showCancel: true }, (r) => {
                    if (r) {
                        try {
                            this.storeSelector.dispatch(actionLoadStationRemove({ stationIds: [this.selectedStation.stat.$.id] }));
                            this.crudStation("delete", [this.selectedStation.stat.$.id], null, this.selectedStation.stat.$.version);
                            this.selectionModel.clear();
                            // this.toastr.error(this.translocoService.translate('toast.featureNotYetSupp', {}, this.translocoService.getActiveLang()));
                        } catch (e) {
                            console.error("crudStation delete station " + e);
                        }
                    }
                });
            }
            case "event": {
                if (!this.isSingleStationAndConnected()) return;
                if (this.accessConfig?.upd === false) return this.accessService.showNoAccess();
                this.sendCommand(i_command, eventName);
                break;
            }
            case "snap": {
                if (!this.isSingleStationAndConnected()) return;
                if (this.waitingSnap) return;
                if (this.accessConfig?.upd === false) return this.accessService.showNoAccess();
                try {
                    // this.stationSnapshotComponent.takeSnapshotUser(this.selectedStation, this.coreAppData[0].businessId);
                    const businessId = !isNullOrUndefOrEmpty(this.selectedStation.stat.$.businessId) ? this.selectedStation.stat.$.businessId : this.user.businessId;
                    this.stationSnapshotComponent.takeSnapshotUser(this.selectedStation, businessId, this.selectedStation?.props?.version);
                    this.waitingSnap = true;
                } catch (e) {
                    console.error("error snap station " + e);
                }
                break;

            }
            case "stats": {
                if (!this.isSingleStationAndConnected()) return;
                try {
                    const stationData: IStationData = _.cloneDeep(this.selectedStation);
                    if (isNullOrUndefOrEmpty(stationData?.stat?.$?.businessId)) {
                        stationData.stat.$.businessId = this.user.businessId;
                    }
                    const dialogRefVal = this.dialog.open(StationLiveComponent, {
                        height: "800px",
                        width: "800px",
                        data: { stationData },
                    });
                    // this.cod(
                    //     this.dialogRefVal.afterClosed().pipe(take(1)).subscribe((local) => {
                    //         // this.setLocal(local);
                    //     })
                    // );
                } catch (e) {
                    console.error("error stats station " + e);
                }

            }
        }
    }

    areYouSureRestart() {
        // legacy player
        if (this.selectedStation && this.selectedStation.stat.$?.version !== "2" && this.selectedStation.stat.$.socket == "1") {
            this.rebootDiag = this.dialog.open(this.rebootDialog, {
                width: "400px",
                height: "330px",
            });
            return;
        }
        // pwa player
        if (this.selectedStation && this.selectedStation.stat.$?.version === "2" && this.selectedStation.stat.$?.wdConnected) {
            this.rebootDiag = this.dialog.open(this.rebootDialog, {
                width: "400px",
                height: "330px",
            });
            return;
        }
        this.toastr.error("WatchDog is not connected. Install WatchDog on player first...");
    }

    isSingleStationAndConnected(): boolean {
        if (Lib.DevMode()) return true;
        if (!this.selectedStation)
            return true;
        if (this.selectedStation.stat.$.connection !== "1") {
            this.toastr.error(this.translocoService.translate("toast.playerNotConnected", {}, this.translocoService.getActiveLang()));
            return false;
        }
        return true;
    }

    openSceneEditor() {
        this.assignedScene = this.formGroup.get("player_data_id").value;
        if (isNullOrUndefOrEmpty(this.assignedScene)) return this.toastr.error(this.translocoService.translate("general.notSceneAssigned", {}, this.translocoService.getActiveLang()));
        this.router.navigateByUrl(`/editor/list/${this.assignedScene}`);
    }

    showToast(i_command) {
        if (this.debugMode) {
            this.toastr.info("Remote " + this.selectionModel.selected[0] + " " + i_command, `sending to ${this.selectionModel.selected} ${this.selectionModel.selected.length} ${(this.selectionModel.selected.length + this.selectionModel.selected.length === 1 ? " screen " : " screens ")}`);
        } else {
            this.toastr.info("Remote command sent: " + i_command, `sending to ${this.selectionModel.selected} ${this.selectionModel.selected.length} ${(this.selectionModel.selected.length + this.selectionModel.selected.length === 1 ? " screen " : " screens ")}`);
        }
    }

    openCategoryTree() {
        this.dialog.open(DialogCategoryTreeComponent, {
            width: "500px",
            data: {
                categories: this.categories,
                treePath: this.formGroup.controls["tree_path"].value,
                callback: (treePath: string) => {
                    this.onUpdateCategory(treePath);
                },
            },
        });
    }

    download(value) {
        window.open(this.appStatic[value], "_blank");
    }

    private findBusinessInSelectedItem(i_businessId: Id) {
        const f = this.selectionModel.selected.find((id) => {
            return i_businessId === String(id);
        });
        return f;
    }

    private sendCommand(i_command, i_param = "SignageStudioLite") {
        if (this.accessConfig?.upd === false) return this.accessService.showNoAccess();
        this.showToast(i_command);
        if (this.coreAppData[0].dashboard) {
            this.cod(
                from(this.selectionModel.selected).pipe(
                    take(this.selectionModel.selected.length),
                    switchMap((i_stationId) => {
                        return this.storeSelector.getStationStats().pipe(
                            take(1),
                            map(stations => {
                                return stations.filter(a => a.$.station_business_id === String(i_stationId));
                            }));
                    }),
                    mergeMap((i_stations): Observable<Array<ICredentialsDataWrap>> => {
                        return this.storeSelector.getEnterpriseBusinessUsers().pipe(
                            take(1),
                            map((b) => {
                                return b.BusinessUsers.reduce((acc, user) => {
                                    if (user.$.businessId === i_stations[0].$.businessId) acc.push({
                                        user,
                                        stations: i_stations[0],
                                    });
                                    return acc;
                                }, []);
                            }));
                    }),
                    mergeMap((values: Array<ICredentialsDataWrap>) => {
                        const name = values[0].user.$.name;
                        return this.enterpriseService.getCredentials(name, values);
                    }),
                    mergeMap((val: ICredentialsWrap) => {
                        const userName = val.returnData[0].user.$.name;
                        const pass = val.result;
                        const id = val.returnData[0].stations.$.id;
                        const source = val.returnData[0].stations.$.source;
                        if (val.returnData["0"].stations.$.version == "2") {
                            const command = i_command == "pushNewContent" ? "start" : i_command;
                            const segment = "Web";
                            const url = `https://${source}/${segment}/sendCommand.ashx?user=${userName}&pass=${Lib.Base64().encode(pass)}&stationId=${val.returnData[0].stations.$.id}&base64=1`;
                            return this._http.post(url, {
                                command: command,
                            }).pipe(
                                retryWithBackoff(url, this.storeSelector, this.toastr),
                                delay(_.random(1, 1000)),
                                map((v) => v),
                            );
                        } else {
                            /** examples
                             const request = new HttpRequest("GET", url, {headers: new HttpHeaders({'Content-Type': 'application/json'}), responseType: "text"}, {reportProgress: false});
                             const headers = new HttpHeaders({'Content-Type': 'application/text'});
                             **/
                            const command = i_command == "pushNewContent" ? "syncAndStart" : i_command;
                            const url = `https://${source}/WebService/sendCommand.ashx?i_user=${userName}&i_password=${Lib.Base64().encode(pass)}&i_stationId=${id}&i_command=${command}&i_param1=${i_param}&i_param2=''&base64=1`;
                            Lib.DevShow(url);
                            return this._http.jsonp<any>(url, "callback").pipe(
                                retryWithBackoff(url, this.storeSelector, this.toastr),
                                delay(_.random(1, 1000)),
                                map((v) => v),
                            );
                        }
                    }),
                ).subscribe((res: any) => {
                    // Lib.DevShow(`send command response 2 ${res?.ret}}`);
                }, (err) => {
                    this.toastr.error(this.translocoService.translate("toast.errSendCommand", {}, this.translocoService.getActiveLang()) + " " + err.message);
                }, () => {
                }),
            );
        } else {
            this.selectionModel.selected.forEach((i_stationId) => {
                const businessStationId = i_stationId;
                const stationId = String(businessStationId).split("_")[0];
                this.cod(
                    this.storeSelector.getStation(businessStationId)
                        .pipe(
                            take(1),
                            switchMap((i_station2) => {
                                if (!i_station2) {
                                    return of(null);
                                }
                                if (i_station2?.version == "2") {
                                    const segment = "Web";
                                    const command = i_command == "pushNewContent" ? "start" : i_command;
                                    const url = `${this.coreAppData[1].protocol}${this.coreAppData[0].businessDomain}/${segment}/sendCommand.ashx?user=${this.coreAppData[0].email}&pass=${Lib.Base64().encode(this.coreAppData[0].passwordNew)}&stationId=${stationId}&base64=1`;
                                    Lib.DevShow(url);
                                    return this._http.post(url, { command }).pipe(
                                        retryWithBackoff(url, this.storeSelector, this.toastr),
                                        delay(_.random(1, 1000)),
                                        map((v) => v),
                                    );
                                } else {
                                    const segment = "WebService";
                                    const command = i_command == "pushNewContent" ? "syncAndStart" : i_command;
                                    const url = `${this.coreAppData[1].protocol}${this.coreAppData[0].businessDomain}/${segment}/sendCommand.ashx?i_user=${this.coreAppData[0].email}&i_password=${Lib.Base64().encode(this.coreAppData[0].passwordNew)}&i_stationId=${stationId}&i_command=${command}&i_param1='SignageStudioLite'&i_param2=''&base64=1`;
                                    if (isHostDevOrLocal) {
                                        console.log("SignagePlayer " + command);
                                    }
                                    return this._http.jsonp<any>(url, "callback").pipe(
                                        retryWithBackoff(url, this.storeSelector, this.toastr),
                                        delay(_.random(1, 1000)),
                                        map((v) => v),
                                    );
                                }

                            }),
                        ).subscribe((final) => {

                        },
                    )
                )
            })
        }
    }

    onTagChanged(v) {
        const station: IStation = _.cloneDeep(this.formGroup.value);
        const tags = isNullOrUndefOrEmpty(station.log_tags) ? [] : station.log_tags.split(",");
        const idx = tags.indexOf(v.name);
        if (idx > -1) {
            tags.splice(idx, 1);
        } else {
            tags.push(v.name);
        }
        station.log_tags = tags.join();
        this.formGroup.controls["log_tags"].patchValue(station.log_tags, { emitEvent: true, onlySelf: false });
        this.updateSingle(station);
    }

    private crudStation(command: ICRUDCommand, id, body, stationVersion) {
        if (this.accessConfig?.upd === false) return this.accessService.showNoAccess();
        let table = "";
        let primary = "";
        if (stationVersion == "1") {
            table = "branch_stations";
            primary = "branch_station_id";
        } else if (stationVersion == "2") {
            table = "stations";
            primary = "station_id";
            if (body && "assigned_to" in body) {
                delete body["assigned_to"];
            }
        } else {
            return;
        }

        this.storeSelector.dispatch(actionCRUDRecord({
            saveRecord: {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command,
                primary,
                table,
                body,
                id,
            },
        }));
    }
}

